import React, { useState, useEffect } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const VitalChart = ({ array_time, array_hr, array_rr }) => {
  // 배열들을 차트용 데이터 포맷으로 변환 (array_time, hr, rr이 같은 길이라고 가정)
  const data = array_time.map((time, idx) => ({
    time,
    heartRate: array_hr[idx],
    respRate: array_rr[idx],
  }));

  const renderCustomizedLabel = (props) => {
    const { x, y, value } = props;
    return (
      <text x={x} y={y - 10} fill="#666" fontSize="12" textAnchor="middle">
        {value}
      </text>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="heartRate" stroke="#F75C5D" name="맥박수 (HR)"  label={renderCustomizedLabel}/>
        <Line type="monotone" dataKey="respRate" stroke="#3889ff" name="호흡수 (RR)" label={renderCustomizedLabel}/>
      </LineChart>
    </ResponsiveContainer>
  );
};

export default VitalChart;